import { FunctionField, SimpleForm, TextInput, ReferenceInput, AutocompleteInput, required, SelectInput, useRedirect } from 'react-admin';
import { Typography, Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useWatch } from 'react-hook-form';
import { calculatePrompt } from  'skylar-agent/PromptCalc';
import { useState, useEffect } from 'react';

export const PromptField = () => {
	//const record = useRecordContext( props );
	//const [ name, character_details, personality_config, dialog_style ] = useWatch({ name: [ 'name', 'character_details', 'personality_config', 'dialog_style' ] });
	//const record = { character_details, personality_config, dialog_style };
	const record = useWatch();

	return (
		<>
			<Typography>Prompt</Typography>
			<FunctionField record={record} render={calculatePrompt} sx={{whiteSpace: 'pre' }} />
		</>
	);
};

const TemplateSelectInput = () => {
	const [templateChoices, setTemplateChoices] = useState([]);

	useEffect(() => {
		const fetchTemplates = async () => {
			try {
				const response = await fetch('/api/orbs/templates', { credentials: 'include' });
				const templates = await response.json();
				setTemplateChoices(templates);
			} catch (error) {
				console.error('Failed to fetch templates:', error);
			}
		};
		fetchTemplates();
	}, []);

	return (
		<SelectInput source="view_template" choices={templateChoices} defaultValue='default' />
	);
};

// Library input with edit button
const LibraryInputWithEdit = () => {
	const redirect = useRedirect();
	const libraryId = useWatch({ name: 'library_id' });

	const handleEditLibrary = () => {
		if (libraryId) {
			redirect('edit', 'libraries', libraryId);
		}
	};

	return (
		<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
			<ReferenceInput source="library_id" defaultValue="0" reference="libraries">
				<AutocompleteInput sx={{ minWidth: 300 }} />
			</ReferenceInput>
			{libraryId && (
				<Tooltip title="Edit Library">
					<IconButton
						onClick={handleEditLibrary}
						color="primary"
						sx={{ mt: 1 }}
					>
						<EditIcon />
					</IconButton>
				</Tooltip>
			)}
		</Box>
	);
};

export const FormFields = (
	<SimpleForm>
		<TextInput source="name" validate={required()} />
		<TextInput source="description" fullWidth helperText="Used for internal documentation purposes only." />
		<ReferenceInput source="voice_id" reference="voices">
			<AutocompleteInput validate={required()} />
		</ReferenceInput>

		<TextInput source="hostname" defaultValue="" helperText="Map this Orb to Host requested in URL" />
		<TextInput source="prompt" multiline />
		<TemplateSelectInput />
		<LibraryInputWithEdit />
	</SimpleForm>
);
